export default "__VITE_ASSET__b24f02b4__"